module.exports = __webpack_public_path__ + "img/partner_dashboard.f7724a52.svg";